// extracted by mini-css-extract-plugin
module.exports =  {"tag":"dJ4K5LE","interactive":"eMMhRDB","size-sm":"Bzpn01W","sizeSm":"Bzpn01W","variant-outline":"v6_N5Lp","variantOutline":"v6_N5Lp"};